import { render, staticRenderFns } from "./print-content-area.component.vue?vue&type=template&id=c6a81942&"
import script from "./print-content-area.component.vue?vue&type=script&lang=ts&"
export * from "./print-content-area.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports